export default "__VITE_ASSET__CJxAZf6r__"